import isEmpty from 'lodash-es/isEmpty';
import trim from 'lodash-es/trim';
import { type HTMLAttributes, type ReactNode, useMemo } from 'react';
import { Link } from 'react-router';
import { PerformanceReviewTab } from '@/common/types';

interface Props extends HTMLAttributes<HTMLAnchorElement> {
  performanceReviewId: string | null | undefined;
  tab?: PerformanceReviewTab;
  children: ReactNode;
  openInNew?: boolean;
}

export const PerformanceReviewLink = ({
  performanceReviewId,
  tab = PerformanceReviewTab.OVERVIEW,
  children,
  openInNew,
  ...props
}: Props) => {
  const canonicalId = useMemo(
    () =>
      !performanceReviewId || isEmpty(trim(performanceReviewId)) || !/^\d+/.test(trim(performanceReviewId))
        ? null
        : trim(performanceReviewId),
    [performanceReviewId],
  );

  if (!canonicalId) return children;

  return (
    <Link
      {...props}
      to={`/performance-review/edit/${canonicalId}${tab ? `/${tab}` : ''}`}
      target={openInNew ? '_blank' : undefined}
    >
      {children}
    </Link>
  );
};
